import React from 'react';

export default function Drawer({ open, onClose, conversations, currentId, onSelect, onNew }) {
  const grouper = (convs) => {
    const today = new Date(); today.setHours(0,0,0,0);
    const week = new Date(today); week.setDate(week.getDate() - 7);
    const groups = { "Aujourd'hui": [], 'Cette semaine': [], 'Ce mois': [], 'Plus ancien': [] };
    convs.forEach(c => {
      const d = new Date(c.created_at);
      if (d >= today) groups["Aujourd'hui"].push(c);
      else if (d >= week) groups['Cette semaine'].push(c);
      else if (d.getMonth() === today.getMonth()) groups['Ce mois'].push(c);
      else groups['Plus ancien'].push(c);
    });
    return groups;
  };

  const groups = grouper(conversations);

  return (
    <>
      <div
        onClick={onClose}
        style={{
          display: open ? 'block' : 'none',
          position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.6)', zIndex: 40,
        }}
      />
      <div style={{
        position: 'fixed', top: 0, left: 0, bottom: 0, width: '72%', maxWidth: 280,
        background: '#0d1117', borderRight: '0.5px solid #1a2744',
        zIndex: 50, padding: '20px 14px',
        transform: open ? 'translateX(0)' : 'translateX(-100%)',
        transition: 'transform 0.25s ease',
        display: 'flex', flexDirection: 'column', gap: 4,
        overflowY: 'auto',
      }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 14 }}>
          <span style={{ color: '#FFD700', fontSize: 14, fontWeight: 600 }}>Conversations</span>
          <button onClick={onClose} style={{ background: 'none', border: 'none', color: '#4a7abf', fontSize: 18, cursor: 'pointer', lineHeight: 1 }}>✕</button>
        </div>

        <button onClick={() => { onNew(); onClose(); }} style={{
          background: '#FFD700', color: '#0a0a0a', border: 'none', borderRadius: 8,
          padding: '9px 12px', fontSize: 12, fontWeight: 600, cursor: 'pointer', marginBottom: 8,
        }}>
          + Nouvelle conversation
        </button>

        {Object.entries(groups).map(([label, convs]) =>
          convs.length > 0 && (
            <div key={label}>
              <p style={{ fontSize: 10, color: '#FFD700', fontWeight: 600, letterSpacing: '0.06em', textTransform: 'uppercase', margin: '10px 4px 5px' }}>{label}</p>
              {convs.map(c => (
                <div
                  key={c.id}
                  onClick={() => { onSelect(c); onClose(); }}
                  style={{
                    padding: '8px 10px', borderRadius: 8, marginBottom: 3, cursor: 'pointer',
                    background: c.id === currentId ? '#0e2040' : 'transparent',
                    border: `0.5px solid ${c.id === currentId ? '#1e3a6e' : 'transparent'}`,
                    transition: 'background 0.15s',
                  }}
                >
                  <p style={{ fontSize: 12, color: '#c8d4e8', fontWeight: 500, margin: '0 0 2px', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{c.titre}</p>
                  <p style={{ fontSize: 10, color: '#4a7abf', margin: 0 }}>{new Date(c.created_at).toLocaleDateString('fr-FR')}</p>
                </div>
              ))}
            </div>
          )
        )}
      </div>
    </>
  );
}
